import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  WatchlistApprover,
  type WatchlistApproverConstructor,
} from './WatchlistApprover'

export const WatchlistApproverConstructorFactory =
  Factory.Sync.makeFactory<WatchlistApproverConstructor>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    approvalCount: Factory.each(() => faker.random.number({ min: 1, max: 10 })),
  })

export const WatchlistApproverFactory = EntityFactory(
  WatchlistApprover,
  WatchlistApproverConstructorFactory
)
